export default __webpack_public_path__ + "media/images/images_v2/rowover-530678d23cab74cc9534110bbdfe38a7.png";